<template>
  <div class="goods-info-box">
    <!-- 大标题盒子 -->
    <div @click.stop="flagBoxFather" class="title-navToptitle">
      <div class="goods-info-fold-title">
        <div class="goods-info-fold-left">
          <div class="info-fold-line"></div>
          <span>{{ title }}</span>
        </div>
        <div class="goods-info-fold-right">
          <span>{{ fatherBoxIsShow ? "收起" : "展开" }}</span>
          <div class="info-fold-right-image">
            <img
              src="@/assets/images/ic_triangle_green.png"
              :style="{
                transform: `rotate(${fatherBoxIsShow ? '0deg' : '180deg'})`,
              }"
              alt=""
            />
          </div>
        </div>
        <!-- 翻页图片样式 -->
        <div class="to-page right" v-if="fatherBoxIsShow">
          <img src="@/assets/images/ic_lian.png" alt="" />
        </div>
        <div class="to-page left" v-if="fatherBoxIsShow">
          <img src="@/assets/images/ic_lian.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 小标题内容总盒子 -->
    <div class="goods-info-inner-box" v-show-slide:250="fatherBoxIsShow">
      <!-- 子内容的总盒子 goodInfoInner负责当前所有子盒子的总高度  -->
      <div
        class="goods-info-fold-newtitle-box"
        :id="'goodInfoInner' + listData.trace_id"
      >
        <!-- 小标题盒子  goods-info-collapse是内层循环的开关父盒子 -->
        <div
          class="goods-info-collapse"
          v-for="(item, index) in listData.msgItems"
          :key="index"
          :style="{ zIndex: 100 - index }"
        >
          <div
            class="goods-info-fold-innertitle"
            :class="{ active: item.x_isOpen }"
            @click.stop="titleChildSwitch(item)"
          >
            <div class="goods-info-fold-left">
              <div class="info-fold-img">
                <img src="@/assets/images/ic_ date.png" alt="" />
              </div>
              <span>{{ item.ts | formant }}</span>
            </div>
            <div class="goods-info-fold-right">
              <div
                class="info-fold-right-image"
                :style="{
                  transform: `rotate(${item.x_isOpen ? '0deg' : '180deg'})`,
                }"
              >
                <img src="@/assets/images/ic_triangle_green.png" alt="" />
              </div>
            </div>
          </div>
          <div
            class="goods-content-allbox"
            v-show-slide:250="item.x_isOpen"
            :class="item.txid"
          >
            <!-- 具体盒子内容 -->
            <div class="goods-info-content" :id="item.txid">
              <slot :itemData="item" />
              <div class="goods-characteristic">
                <div class="goods-characteristic-inner">
                  <span @click="toBlockChain(item)">
                    区块链标识：{{ item.txid }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- 内部标题时间线上的翻页连接图标样式 -->
          <div class="goods-info-collapse-leftimage">
            <img src="@/assets/images/ic_lian.png" alt="" />
          </div>
          <div class="goods-info-collapse-rightimage">
            <img src="@/assets/images/ic_lian.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Popup, Toast } from "vant";
Vue.use(Popup);
Vue.use(Toast);
export default {
  props: {
    dataList: {
      type: Object,
    },
    title: String,
  },
  watch: {
    dataList: {
      handler() {
        this.$nextTick(() => {
          console.log(this.dataList);
          if (!this.dataList) {
            return 
          }
          this.listData = JSON.parse(JSON.stringify(this.dataList));
          if (this.listData.msgItems) {
            for (let i = 0; i < this.listData.msgItems.length; i++) {
              const rowData = this.listData.msgItems[i];
              // 默认高度 0
              this.$set(rowData, "x_childHeight", 0);
              if (i == 0) {
                this.$set(rowData, "x_isOpen", true);
              } else {
                //是否展开 默认false
                this.$set(rowData, "x_isOpen", false);
              }
            }
         
            this.$forceUpdate();
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      testImage:
        "https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3957346327,171699722&fm=15&gp=0.jpg",
      listData: [],
      // 控制父盒子展开的高度
      fatherBoxHight: 0,
      //父盒子是否已展开
      fatherBoxIsShow: true,
    };
  },
  created() {},
  mounted() {
    // this.$nextTick(()=>{this.flagBoxFather()
    //     })
    // setTimeout(()=>{
    //   this.flagBoxFather()
    // },3000)
  },
  updated() {
    // this.upDatFatherHeight();
    // console.log('页面更新')
  },
  methods: {
    // 跳往区块链标识页面
    toBlockChain(item) {
      console.log(item);
      this.$router.push(`/Look?ts=${item.ts}&txid=${item.txid}`);
    },
    flagBoxFather() {
      this.fatherBoxIsShow = !this.fatherBoxIsShow;
      console.log(1);
    },
    titleChildSwitch(item) {
      console.log(item);
      item.x_isOpen = !item.x_isOpen;
    },
    // init(){
    //   this.bus.$on('getItemVal',(...args)=>{
    //     this.options = args[0]
    //     console.log(args[0].chainProduct.chainProductPics)
    //     // this.images = args[0].chainProduct.chainProductPics
    //   })
    // }
  },
};
</script>
<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
.title-navToptitle {
  padding: 0 20px;
}
#goodInfoInner,
.goods-info-fold-newtitle-box {
  padding: 0 20px;
}
::v-deep .van-swipe-item {
  .imagebg {
    width: 530px;
    height: 530px;
    // border-radius: 16px;
    // background: url("https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3957346327,171699722&fm=15&gp=0.jpg")
    //   no-repeat;
    background-size: contain;
    background-position: center center;
  }
}
::v-deep .swipe {
  border-radius: 15px;
}
.goodsInfo {
  .content {
    font-family: PingFang SC;
    line-height: 46px;
    color: #222;

    .info-wrap {
      padding: 0 0 16px 30px;
      // border-bottom: 1px solid #d4d6d5;
      font-family: PingFang SC;
      line-height: 34px;
      position: relative;

      .tle {
        margin: 20px 0;
        font-size: 28px;
        font-weight: bold;
      }

      .info {
        color: #808080;
      }

      &::before {
        content: "";
        position: absolute;
        top: 11px;
        left: 0;
        background-color: #26907a;
        width: 8px;
        height: 8px;
      }
    }
  }
}
.goods-info-box {
  width: 100%;
  margin-bottom: 28px;
  .goods-info-fold-title {
    width: 100%;
    height: 96px;
    background-color: #f5f5f5;
    box-shadow: 0px 4px 8px rgba(0, 45, 41, 0.2);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    padding: 24px 20px;
    .goods-info-fold-left {
      font-size: 34px;
      color: #222;
      display: flex;
      align-items: center;
      height: 100%;
      .info-fold-line {
        width: 8px;
        height: 34px;
        background-color: #26907a;
        margin-right: 16px;
      }
    }
    .goods-info-fold-right {
      font-size: 26px;
      color: #11745f;
      display: flex;
      span {
        margin-right: 8px;
      }
      align-items: center;
      .info-fold-right-image {
        width: 20px;
        height: 20px;
        transition: all 0.2s;

        img {
          transition: all 0.2s;
          width: 100%;
          height: 100%;
        }
      }
    }
    .to-page {
      width: 20px;
      height: 64px;
      // background-color: skyblue;
      position: absolute;
      bottom: -40px;
      z-index: 999;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .to-page.right {
      right: 10px;
    }
    .topage.left {
      left: 0;
    }
  }
}

.goods-info-fold-newtitle-box {
  width: 100%;
  height: auto;

  // padding-bottom: 60px;
  transition: all 0.3s;
  .goods-info-fold-innertitle {
    width: 100%;
    height: 112px;
    // box-shadow: 0px 4px 8px rgba(0, 45, 41, 0.2);
    border-radius: 16px;
    background-color: #f5f5f5;

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 20px;
    position: relative;
    .goods-info-fold-left {
      font-size: 30px;
      color: #11745f;
      display: flex;
      height: 100%;
      align-items: center;
      .info-fold-img {
        width: 40px;
        height: 40px;
        img {
          width: 100%;
          height: 100%;
        }
        margin-right: 16px;
      }
    }
    .goods-info-fold-right {
      font-size: 26px;
      color: #11745f;

      .info-fold-right-image {
        width: 20px;
        height: 20px;
        transform: rotate(-180deg);
        transition: all 0.2s;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  // 具体盒子内容部分
  .goods-info-content {
    width: 100%;
    // height: ;
    padding-top: 48px;
    .goods-info-content-image {
      // padding: 0 40px;
      width: 530px;
      margin: 0 auto;
      // display: flex;
      // margin: 0 auto;
      // justify-content: center;
    }
  }
}
.goods-info-inner-box {
  overflow: hidden;
  transition: all 0.2s;
  margin-top: 20px;
  // padding-bottom: 20px;
}

.goods-info-fold-innertitle.active {
  // border-bottom: 1px dashed #BCBCBC;
  box-shadow: none;
  // border-radius: 0;
}
.goods-info-fold-innertitle.active::before {
  content: "";
  width: 92%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  // background-color: pink;
  border-bottom: 1px dashed #bcbcbc;
  height: 1px;
}
.goods-info-collapse:not(:last-child) {
  margin-bottom: 20px;
}
.goods-info-collapse:last-child .goods-info-collapse-leftimage,
.goods-info-collapse:last-child .goods-info-collapse-rightimage {
  display: none;
}
.goods-info-collapse {
  border-radius: 16px;
  box-shadow: 0px 4px 8px rgba(0, 45, 41, 0.2);
  position: relative;
  background-color: #f5f5f5;
  z-index: 10;
  .goods-info-collapse-leftimage {
    width: 20px;
    height: 64px;
    // background-color: skyblue;
    position: absolute;
    bottom: -40px;
    z-index: 999;
    left: 20px;
    z-index: 99;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .goods-info-collapse-rightimage {
    width: 20px;
    height: 64px;
    // background-color: skyblue;
    position: absolute;
    bottom: -40px;
    z-index: 999;
    right: 10px;
    img {
      width: 100%;
      height: 100%;
    }
    z-index: 99;
  }
}

.goods-content-allbox {
  overflow: hidden;
  transition: all 0.2s;
}
div {
  box-sizing: border-box;
}
.goods-characteristic {
  width: 100%;
  //   padding: 48px 20px;
  padding: 48px 0;
  .goods-characteristic-inner {
    width: 530px;
    // height: 64px;
    margin: 0 auto;

    line-height: 38px;
    padding: 12px 30px;
    font-size: 28px;
    color: #11745f;
    border: 1px solid #11745f;
    border-radius: 32px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>